/* ==========================================================================
   contact.js — Contact 页面交互
   ========================================================================== */

$(function () {
    /* ============ Topic Dropdown ============ */
    $('.topic_trigger').on('click', function (e) {
        e.stopPropagation();
        $('.topic_select').toggleClass('open');
    });

    $(document).on('click', function () {
        $('.topic_select').removeClass('open');
    });

    $('.topic_options li').on('click', function (e) {
        e.stopPropagation();
        $('.topic_value').text($(this).text());
        $('.topic_options li').removeClass('active');
        $(this).addClass('active');
        $('.topic_select').removeClass('open');
        $('.topic_select').closest('.form_item').removeClass('error');
        $('.form_error').removeClass('show');
    });

    /* ============ Form Validation ============ */
    function validEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function checkForm() {
        var valid = true;
        var name = $.trim($('#name').val());
        var email = $.trim($('#email').val());
        var topic = $.trim($('.topic_value').text());
        var message = $.trim($('#message').val());

        if (!name) {
            $('#name').closest('.form_item').addClass('error');
            valid = false;
        } else {
            $('#name').closest('.form_item').removeClass('error');
        }

        if (!validEmail(email)) {
            $('#email').closest('.form_item').addClass('error');
            valid = false;
        } else {
            $('#email').closest('.form_item').removeClass('error');
        }

        if (!topic || topic === 'Select a topic...') {
            $('.topic_select').closest('.form_item').addClass('error');
            valid = false;
        } else {
            $('.topic_select').closest('.form_item').removeClass('error');
        }

        if (!message) {
            $('#message').closest('.form_item').addClass('error');
            valid = false;
        } else {
            $('#message').closest('.form_item').removeClass('error');
        }

        return valid;
    }

    $('#contact_form').on('submit', function (e) {
        e.preventDefault();

        if (checkForm()) {
            $('.form_error').removeClass('show');
            $('.form_item').removeClass('error');
            $('#success_modal').addClass('show');
            this.reset();
            $('.topic_value').text('Select a topic...');
            $('.topic_options li').removeClass('active').first().addClass('active');
        } else {
            $('.form_error').addClass('show');
        }
    });

    $('.send_btn').on('click', function (e) {
        e.preventDefault();
        $('#contact_form').trigger('submit');
    });

    /* ============ Success Modal ============ */
    $('#success_modal .modal_close, #success_modal .modal_btn, #success_modal .modal_mask').on('click', function (e) {
        e.preventDefault();
        $('#success_modal').removeClass('show');
    });
});
